import { render } from "./ThemeProvider.vue?vue&type=template&id=e23357aa"
import script from "./ThemeProvider.vue?vue&type=script&lang=js"
export * from "./ThemeProvider.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__